import 'date-fns';
import React, { useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import styles from '../newOrder/components/DeliveryTime/pickUpDeliveryTime/styles.js';

function SelectSearchTypeOptions(props) {
  const [value, setValue] = useState(localStorage.getItem('searchHistory')!==null ? localStorage.getItem('searchHistory') === "no" ? "month" :localStorage.getItem('searchHistory') : "month")
  const handleChange = (event) => {
    setValue(event.target.value);
    props.onChange({
      target: {
        name: props.name,
        value: event.target.value,
      }
    });
  };
 
  return (
    <div>
      <Typography color="primary">Search Type</Typography>
      <RadioGroup value={value} onChange={handleChange} style={styles.radio}>
        <FormControlLabel value="month" control={<Radio color='primary'/>} label='Month'/>
        <FormControlLabel value="date" control={<Radio color='primary'/>} label='Date'/>
      </RadioGroup>    
    </div>
  );
}

export default SelectSearchTypeOptions;

